module.exports = __webpack_public_path__ + "img/logo.3b7f8d72.png";